import posthog from "posthog-js";
import { postHogConfig } from "../utils/postHogConfig";

interface IdentifyPostHogSessionParams {
  userId: string;
  name?: string | null;
  email?: string | null;
  role?: string | null;
  teamId?: string | null;
  workspaceId?: string | null;
}

const { enabled, apiKey, pageTrackingEnabled } = postHogConfig;

export const identifyPostHogSession = ({
  userId,
  name,
  email,
  role,
  teamId,
  workspaceId,
}: IdentifyPostHogSessionParams) => {
  if (typeof window === "undefined") return;
  if (!enabled || !apiKey) return;

  try {
    posthog.identify(userId, {
      name: name || null,
      email: email || null,
      role: role || null,
      teamId: teamId || null,
    });

    if (workspaceId) {
      posthog.group("workspace", workspaceId, {
        name: name || null,
        role: role || null,
      });
    }

    if (import.meta.env.DEV) {
      console.log("[PostHog] Identified", { userId, name, role, workspaceId });
    }
  } catch (e) {
    if (import.meta.env.DEV) {
      console.error("[PostHog] Identify failed", e);
    }
  }
};

export const capturePostHogPageView = (
  pathname: string,
  search: string = "",
) => {
  if (typeof window === "undefined") return;
  if (!enabled || !apiKey) return;
  if (!pageTrackingEnabled) return;

  if (import.meta.env.DEV) {
    console.log(
      "[PostHog] PageView ==> Path: ",
      pathname,
      " , appConfig.posthog",
      postHogConfig,
    );
  }

  try {
    posthog.capture("$pageview", {
      $current_url: window.location.origin + pathname + search,
      $pathname: pathname,
    });
  } catch (e) {
    if (import.meta.env.DEV) {
      console.error("[PostHog] Pageview capture failed", e);
    }
  }
};